
    export default {
      mounted() {
        this.onClick = () => requestAnimationFrame(() => this.sync())
        this.el.addEventListener("click", this.onClick)
        this.sync()
      },

      updated() {
        this.sync()
      },

      sync() {
        const source = document.documentElement.getAttribute("data-theme-source")
        const current = source === "system" ? "system" : document.documentElement.getAttribute("data-theme")
        this.el.querySelectorAll("[data-phx-theme]").forEach((btn) => {
          btn.setAttribute("aria-pressed", String(btn.dataset.phxTheme === current))
        })
      },

      destroyed() {
        this.el.removeEventListener("click", this.onClick)
      }
    }
  